import axios from 'axios';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import socket from '../_helper/socketInstance';
const baseURL = process.env.REACT_APP_BASE_URL;
const baseURLNAKBHO = process.env.REACT_APP_BASE_URL_NAKBHO || "https://dev-api.nakbho.com/";

const axiosInstance = axios.create({
    baseURL
});

const axiosNAKBHOInstance = axios.create({ baseURL: baseURLNAKBHO });

const getClinic = () => {
    try {
        const raw = localStorage.getItem('currentHospitalAdmin');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const logoutUserOld = async () => {
    const admin = getClinic();
    const axiosAPI = axios.create({
        baseURL
    });
    try {
        const response = await axiosAPI.get(`clinic_admin/logout/${admin._id}`);
        if (response.data.status === "success") {
            logoutAndRedirectToLogin();
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        logoutAndRedirectToLogin();
    } finally {
    }
};

const logoutAndRedirectToLogin = () => {
    const admin = getClinic();
    if (socket && socket.connected && admin) {
        socket.emit('userLogout', { userId: admin._id, userRole: admin.role }, () => {
            socket.disconnect();
        });
    }
    localStorage.removeItem("profileURL");
    localStorage.removeItem("hospitalAdminAuth");
    localStorage.removeItem("currentHospitalAdmin");
    localStorage.removeItem("auth0_hospital_admin_profile");
    localStorage.removeItem("Name");
    localStorage.setItem("authenticated", false);
    window.location.href = `${process.env.PUBLIC_URL}/login`;
};

const logoutUser = () => {
    localStorage.removeItem("profileURL");
    localStorage.removeItem("currentLabAuth");
    localStorage.removeItem("currentLab");
    localStorage.removeItem("auth0_hospital_admin_profile");
    localStorage.removeItem("Name");
    localStorage.setItem("authenticated", false);
    window.location.href = `${process.env.PUBLIC_URL}/login`;
}

// Utility function to display error messages
const displayError = (message, details = '') => {
    toast.warning(message);
    if (details) {
        console.error(details);
    }
};

// Utility function to display SweetAlert messages
const showAlert = (icon, title, text) => {
    return Swal.fire({
        icon,
        title,
        html: text,
    });
};

// ===== Interceptor Config (common for both) =====
const addInterceptors = (instance) => {
    instance.interceptors.request.use(
        (config) => {
            const lang = i18next.language;
            const token = localStorage.getItem('currentLabAuth');

            if (lang) {
                config.headers['Accept-Language'] = lang;
            }
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response) {
                const { status, data } = error.response;
                const errorMessage = data.message || 'An error occurred';

                switch (status) {
                    case 400:
                        toast.warning(errorMessage);
                        break;
                    case 0:
                        Swal.fire({
                            icon: 'question',
                            title: 'Connection Is Not Stable',
                            html: `Please check your internet connection.<br>Detail: ${error.message}`
                        });
                        break;
                    case 401:
                        Swal.fire({
                            icon: 'error',
                            title: 'Session Expired',
                            html: errorMessage
                        })
                        .then(logoutUser);
                        break;
                    case 422:
                        if (data.errors && data.errors.length > 0) {
                            data.errors.forEach((msg) => toast.warning(msg));
                        } else {
                            toast.warning('Unprocessable Entity error occurred');
                        }
                        break;
                    default:
                        toast.warning(errorMessage);
                        console.error(data.errors || `Status code: ${status}`);
                        break;
                }
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Request setup error:', error.message);
            }
            return Promise.reject(error);
        }
    );
};

// Apply interceptors to both
addInterceptors(axiosInstance);
addInterceptors(axiosNAKBHOInstance);

// // Add a request interceptor
// axiosInstance.interceptors.request.use(
//     (config) => {
//         const lang = i18next.language;
//         const token = localStorage.getItem('currentLabAuth');

//         if (lang) {
//             config.headers['Accept-Language'] = lang;
//         }
//         if (token) {
//             config.headers['Authorization'] = `Bearer ${token}`;
//         }

//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// // Add a response interceptor
// axiosInstance.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.response) {
//             const { status, data } = error.response;
//             const errorMessage = data.message || 'An error occurred';

//             switch (status) {
//                 case 400:
//                     displayError(errorMessage);
//                     break;
//                 case 0:
//                     showAlert('question', 'Connection Is Not Stable', `Please check your internet connection. It seems that it is not stable.<br>Detail: ${error.message}`);
//                     break;
//                 case 401:
//                     showAlert('error', 'Session Expired', errorMessage).then(logoutUser);;
//                     break;
//                 case 422:
//                     if (data.errors && data.errors.length > 0) {
//                         data.errors.forEach(displayError);
//                     } else {
//                         displayError('Unprocessable Entity error occurred');
//                     }
//                     break;
//                 default:
//                     displayError(errorMessage, data.errors || `Status code: ${status}`);
//                     break;
//             }
//         } else if (error.request) {
//             console.error('No response received:', error.request);
//         } else {
//             console.error('Request setup error:', error.message);
//         }
//         return Promise.reject(error);
//     }
// );

export { axiosInstance, axiosNAKBHOInstance };
export default axiosInstance;
